import { useContext, useEffect } from "react";
import { Form, Col, Row, Container } from "react-bootstrap";
import { T } from "react-translator-component";
import { NavLink } from "react-router-dom";
import { HotelContext } from "../../context/hotel";
import { getCDNImage } from "../../globals";
import { Edit as EditIcon, Avatar, Boy, Man } from "../../components/Icons";
import isApartYou from "../../components/CheckIn/isApartYou";
import { isOffgrid, isHostz } from "../../components/CheckIn/hotelConditions";

const PassengerItemComponent = ({ passenger, linked_checkin_idx = false, idx, checkIn, editMode, errors, setPassengerOmmit }) => {
    const { data: hotel } = useContext(HotelContext);

    let _url_to_edit = `passenger/${idx}`;
    let _error = false;

    if (linked_checkin_idx === undefined || linked_checkin_idx === false) {
        if (errors[`passengers[${idx}]_name`] ||
            errors[`passengers[${idx}]_dni`] ||
            errors[`passengers[${idx}]_surname`] ||
            errors[`passengers[${idx}]_birthday`] ||
            errors[`passengers[${idx}]_nationality`]) {
            _error = true;
        }
    } else {
        _url_to_edit = `linked_checkin_passenger/${linked_checkin_idx}/${idx}`
        console.log('29dic - linked_checkin_idx', linked_checkin_idx);
        if (errors?.[`linked_checkins[${linked_checkin_idx}]_passengers[${idx}].name`] !== undefined || errors?.[`linked_checkins[${linked_checkin_idx}]_passengers[${idx}].dni`] !== undefined) {
            _error = true
        }
    }

    if (!passenger) return false;

    const _reservation = JSON.parse(passenger.reservation);
    let _name = [
        _reservation?.title,
        _reservation?.firstName,
        _reservation?.lastName,
    ]
        .filter((str) => str && str !== "")
        .join(" ")
        .trim();

    const childrenAges = checkIn.reservation?.childrenAges || checkIn.reservation?.guestCounts?.childAges;
    const adults = checkIn.reservation?.adults || checkIn.reservation?.guestCounts?.adults;
    const _isBoy = childrenAges && idx + 1 > adults;
    const _age = _isBoy ? childrenAges[idx - adults] : -1;

    const renderName = (age) => {
        let res = T("checkin.child");
        if (age) {
            res += ` (${age} ${T("checkin.years")}) `;
        }
        return res;
    }

    return (
        <Container
            className="card-generic mb-2"
            style={{
                boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.11), 0 6px 20px 0 rgba(0, 0, 0, 0.11)",
                minHeight: 69.1,
                borderColor:
                    _error
                        ? "red"
                        : "#f3f3f3",
                borderWidth: 1,
                borderStyle: "solid",
            }}
            key={`checkin-passenger-${idx}`}
        >
            <Row>
                <Col xs={12} className="d-flex" style={{ gap: 10 }}>
                    <div>
                        {!passenger.ommited && passenger.name && (
                            passenger.photos?.selfie ?
                                <div
                                    style={{
                                        backgroundImage: passenger.photos?.selfie
                                            ? "url(" + getCDNImage(passenger.photos.selfie) + ")"
                                            : "none",
                                        backgroundPosition: "center",
                                        backgroundSize: "cover",
                                        backgroundRepeat: "no-repeat",
                                        backgroundColor: "#DDD",
                                        height: 40,
                                        width: 40,
                                        borderRadius: 20,
                                    }}
                                /> :
                                <div style={{ height: 40, width: 40, borderRadius: 20, backgroundColor: "#DDD", alignItems: "center", justifyContent: "center", display: "flex" }}>
                                    <Avatar width={30} height={30} color="white" />
                                </div>

                        )}
                        {passenger.reservation &&
                            (passenger.ommited || !passenger.name) &&
                            _isBoy && <Boy width={20} height={20} />}
                        {passenger.reservation &&
                            (passenger.ommited || !passenger.name) &&
                            !_isBoy && <Man width={20} height={20} />}
                    </div>
                    <div className="flex-fill">
                        {!passenger.ommited && passenger.name && (
                            <>
                                {isOffgrid(hotel.id) && (
                                    <>
                                        <p className="request-type mb-0 text-muted">
                                            <b>#{idx + 1}.</b>{" "}
                                            {/* {passenger.gender && T(`checkin.inputs.gender.${passenger.gender}`)} -{" "}
                                            {passenger.birthday && T("checkin.date-of-birth")}: {passenger.birthday} -{" "}
                                            {passenger.age && T("checkin.age")}: {passenger.age} */}
                                        </p>
                                        <p className="mb-0">
                                            {passenger.name} {passenger.surname}
                                            {/* {passenger.dniType && <small className="text-muted">
                                                ({passenger.dniType} {passenger.dni})
                                            </small>} */}
                                        </p>
                                    </>
                                )}
                                {!isOffgrid(hotel.id) && (
                                    <>
                                        <p className="request-type mb-0 text-muted">
                                            <b>#{idx + 1}.</b>{" "}
                                            {passenger.gender && T(`checkin.inputs.gender.${passenger.gender}`)} -{" "}
                                            {passenger.birthday && T("checkin.date-of-birth")}: {passenger.birthday} -{" "}
                                            {passenger.age && T("checkin.age")}: {passenger.age}
                                        </p>
                                        <p className="mb-0">
                                            {passenger.surname}, {passenger.name}{" "}
                                            {passenger.dniType && <small className="text-muted">
                                                ({passenger.dniType} {passenger.dni})
                                            </small>}
                                        </p>
                                    </>
                                )}
                            </>
                        )}
                        {passenger.reservation && (passenger.ommited || !passenger.name) && (
                            <>
                                <p className="mb-0">
                                    <span
                                        className="text-uppercase general-text-sm"
                                        style={{ color: "#988460" }}
                                    >
                                        {_isBoy
                                            ? renderName(_age)
                                            : T("checkin.adult")}
                                    </span>
                                </p>
                                {!passenger.ommited && (
                                    <p className="mb-0">
                                        {_name ? _name : <span className="text-muted">{T("checkin.no.name.yet")}</span>}
                                    </p>
                                )}
                                {/* {passenger.ommited && <p className="mb-0 general-text-sm text-info"><FontAwesomeIcon icon={faCaretRight} className="text-info" /> Se completará al momento de arrivo!</p>} */}
                            </>
                        )}
                    </div>
                    {editMode && !passenger.ommited && (
                        <NavLink to={_url_to_edit} className="d-flex align-items-center">
                            <EditIcon width={22} height={22} color="red" />
                        </NavLink>
                    )}
                </Col>
            </Row>
            {_error && (
                <Row>
                    <Col>
                        <small style={{ color: "red" }}>
                            {T("checkin.passengers-error-incomplete")}
                        </small>
                    </Col>
                </Row>
            )}
            {idx > 0 && !isApartYou(hotel.id) && !isHostz(hotel.id) && <Row>
                <Col>
                    <fieldset className="mb-0 ml-0">
                        <legend className="mb-0">
                            <Form.Check inline id="ommited">
                                <Form.Check.Input
                                    id={`passenger-ommited-${idx}`}
                                    className="ml-1 mr-2"
                                    checked={passenger.ommited || false}
                                    onChange={(event) =>
                                        setPassengerOmmit(idx, event.target.checked)
                                    }
                                />
                                <Form.Check.Label className="font-size-sm text-left">
                                    <span className="text-muted">
                                        {T("checkin.guest-complete-later")}
                                    </span>
                                </Form.Check.Label>
                            </Form.Check>
                        </legend>
                        {/* <Objective className="d-flex flex-column" invalid={invalid1} /> */}
                    </fieldset>
                </Col>
            </Row>}
        </Container>)

}

export default PassengerItemComponent;